<template>
 <div class="student-detail-host">
  <v-dialog v-model="hideShow" max-width="1240" persistent scrollable content-class="student-detail-window">
   <v-card class="student-detail-card">
    <div class="sd-header">
     <div class="sd-title-row"><h2>学员详情</h2><v-btn icon aria-label="关闭学员详情" @click="cancel"><v-icon>mdi-close</v-icon></v-btn></div>
     <div v-if="student" class="sd-identity">
      <button type="button" class="sd-avatar" :disabled="!student.avatar" aria-label="查看学员头像" @click="showImageViewer(student.avatar)"><v-avatar size="58"><v-img v-if="student.avatar" :src="imgPrev+student.avatar" :alt="student.studentName" /><span v-else>{{(student.studentName || '学').slice(0,1)}}</span></v-avatar></button>
      <div class="sd-identity-info"><div class="sd-identity-name"><h3>{{student.studentName}}</h3><span class="sd-badge" :class="{'sd-badge-green':student.status==='1'}">{{studentStatusName(student.status)}}</span><span class="sd-meta-tag">{{genderName(student.gender)}}</span><span v-if="student.age !== null && student.age !== undefined && student.age !== ''" class="sd-meta-tag">年龄 {{student.age}}</span></div><div class="sd-identity-meta"><span>学号 {{student.studentNo || '—'}}</span><span>入学 {{student.createAt || '—'}}</span></div></div>
      <div class="sd-primary-actions"><v-btn outlined :disabled="student.status!='1'" @click="updateStudentShow=true"><v-icon left size="16">mdi-account-edit-outline</v-icon>修改资料</v-btn><v-btn depressed color="#d9363e" dark @click="rechargeShow=true"><v-icon left size="17">mdi-wallet-plus-outline</v-icon>缴费</v-btn></div>
     </div>
     <v-progress-linear v-if="detailLoading" indeterminate color="#d9363e" height="2" />
    </div>
    <v-tabs class="sd-tabs" v-model="tab" color="#d9363e" background-color="white" show-arrows @change="tabChanged"><v-tabs-slider color="#d9363e" /><v-tab :disabled="!student">学员信息</v-tab><v-tab :disabled="!student">在读班级</v-tab><v-tab :disabled="!student">学员课表</v-tab><v-tab :disabled="!student">学费账户明细</v-tab><v-tab :disabled="!student">课时账户明细</v-tab></v-tabs>
    <v-card-text ref="detailScroll" class="sd-scroll">
     <v-alert v-if="detailError" outlined type="error" dense>{{detailError}}<v-btn small text @click="getStudentDetail">重试</v-btn></v-alert>
     <div v-if="!student && detailLoading" class="sd-empty" role="status"><v-icon size="32">mdi-account-outline</v-icon><p>正在加载学员档案…</p></div>
     <v-tabs-items v-if="student" v-model="tab" class="sd-tab-content">
      <v-tab-item><div class="sd-overview">
       <aside class="sd-profile">
        <section class="sd-profile-section"><h3>基本资料</h3><dl class="sd-info-grid"><div><dt>生日</dt><dd>{{student.birthday || '—'}}</dd></div><div><dt>生源类型</dt><dd>{{student.sourceName || '—'}}</dd></div><div class="sd-info-wide"><dt>身份证号</dt><dd>{{student.idCardNo || '—'}}</dd></div></dl><div class="sd-status-line"><span>学籍状态 <b>{{studentStatusName(student.status)}}</b></span><v-btn v-if="student.status=='1'" small text color="#718096" @click="closeStudent">结业</v-btn><v-btn v-if="student.status=='2'" small text color="#b94852" @click="openStudent">复学</v-btn></div></section>
        <section class="sd-profile-section"><h3>联系信息</h3><dl class="sd-info-grid"><div><dt>联系人关系</dt><dd>{{student.contactorCall || '—'}}</dd></div><div><dt>联系电话</dt><dd>{{student.contactorMobile || '—'}}</dd></div></dl></section>
        <section class="sd-profile-section"><h3>家长账号</h3><div class="sd-parent-account"><div><label>家长系统账号</label><strong>{{student.appUserMobile || '未绑定'}}</strong></div><v-btn v-if="student.appUserMobile" small text color="#718096" @click="unbindParentMobile">解绑</v-btn><v-btn v-else small outlined color="#b94852" @click="showBindParentMobile">去开通</v-btn></div><div class="sd-parent-status"><span>账号激活<span class="sd-badge" :class="{'sd-badge-green':student.appUserIsSignIn=='1','sd-badge-amber':student.appUserIsSignIn=='0'}">{{student.appUserIsSignIn=='1' ? '已激活' : student.appUserIsSignIn=='0' ? '未激活' : '—'}}</span></span><span>微信绑定<span class="sd-badge" :class="{'sd-badge-green':student.appUserBindWx=='1','sd-badge-amber':student.appUserBindWx=='0'}">{{student.appUserBindWx=='1' ? '已绑定' : student.appUserBindWx=='0' ? '未绑定' : '—'}}</span></span></div></section>
        <section class="sd-profile-section"><h3>更多资料</h3><dl class="sd-info-grid"><div class="sd-info-wide"><dt>就读学校</dt><dd>{{student.fromSchoolName || '—'}}</dd></div><div class="sd-info-wide"><dt>居住片区</dt><dd>{{student.fromRegionName || '—'}}</dd></div><div class="sd-info-wide"><dt>家庭住址</dt><dd>{{student.homeAddress || '—'}}</dd></div></dl></section>
       </aside>
       <div class="sd-main-column">
        <section class="sd-account-section"><div class="sd-section-heading"><div><h3>账户余额</h3><p>各课程课时与金额账户余额</p></div></div>
         <v-progress-linear v-if="accountLoading" indeterminate color="#d9363e" height="2" />
         <v-alert v-if="accountError" outlined type="error" dense>{{accountError}}<v-btn small text @click="getAccountList">重试</v-btn></v-alert>
         <template v-else-if="!accountLoading"><div v-if="!accountGroups.length" class="sd-empty" role="status"><v-icon size="32">mdi-wallet-outline</v-icon><h4>暂无账户记录</h4><p>开通账户后，可在这里查看余额和使用情况</p></div>
          <template v-for="group in accountGroups"><details v-if="group.key==='zero'" :key="group.key" class="sd-completed"><summary>已完结课程 <span>{{group.items.length}} 项</span><small>展开查看</small></summary><div class="sd-account-grid"><article v-for="(item,index) in group.items" :key="item.accountType + '-' + (item.accountId || index)" class="sd-account" :class="{'sd-account-cash':item.accountType==='CASH'}">
   <div class="sd-account-title"><v-icon size="18">{{item.accountType==='CASH' ? 'mdi-wallet-outline' : 'mdi-book-open-page-variant-outline'}}</v-icon><h4>{{item.accountType==='CASH' ? '金额账户' : item.courseName}}</h4></div>
   <div class="sd-account-balance"><span>剩余</span><strong>{{item.balanceAmount}}</strong><span>{{item.accountType==='CASH' ? '元' : '课时'}}</span></div>
   <div class="sd-account-totals"><span>{{item.accountType==='CASH' ? '总金额' : '总课时'}} <b>{{item.totalAmount}}</b></span><span>已用 <b>{{item.usedAmount}}</b></span></div>
   <div v-if="item.expireDate" class="sd-account-expiry"><v-icon size="13">mdi-clock-outline</v-icon>有效期至 {{item.expireDate}}</div>
 </article></div></details><div v-else :key="group.key" class="sd-account-grid"><article v-for="(item,index) in group.items" :key="item.accountType + '-' + (item.accountId || index)" class="sd-account" :class="{'sd-account-cash':item.accountType==='CASH'}">
   <div class="sd-account-title"><v-icon size="18">{{item.accountType==='CASH' ? 'mdi-wallet-outline' : 'mdi-book-open-page-variant-outline'}}</v-icon><h4>{{item.accountType==='CASH' ? '金额账户' : item.courseName}}</h4></div>
   <div class="sd-account-balance"><span>剩余</span><strong>{{item.balanceAmount}}</strong><span>{{item.accountType==='CASH' ? '元' : '课时'}}</span></div>
   <div class="sd-account-totals"><span>{{item.accountType==='CASH' ? '总金额' : '总课时'}} <b>{{item.totalAmount}}</b></span><span>已用 <b>{{item.usedAmount}}</b></span></div>
   <div v-if="item.expireDate" class="sd-account-expiry"><v-icon size="13">mdi-clock-outline</v-icon>有效期至 {{item.expireDate}}</div>
 </article></div></template>
         </template>
        </section>
        <section class="sd-situation"><div class="sd-section-heading"><h3>最新学习状况</h3><v-btn v-if="student.situationDesc" text small color="#b94852" @click="showSituationList">查看全部<v-icon right size="15">mdi-chevron-right</v-icon></v-btn></div><p>{{student.situationDesc || '暂无学习状况记录'}}</p></section>
       </div>
      </div></v-tab-item>
      <v-tab-item><section class="sd-classes"><div class="sd-section-heading"><div><h3>在读班级</h3><p>查看课程安排、进班日期和消课设置</p></div><v-btn depressed color="#d9363e" dark @click="joinClassShow=true"><v-icon left size="16">mdi-account-multiple-plus-outline</v-icon>学员分班</v-btn></div>
       <v-progress-linear v-if="classLoading" indeterminate color="#d9363e" height="2" />
       <v-alert v-if="classError" outlined type="error" dense>{{classError}}<v-btn small text @click="getClassList">重试</v-btn></v-alert>
       <div v-else-if="!classLoading && !classList.length" class="sd-empty" role="status"><v-icon size="32">mdi-google-classroom</v-icon><h4>暂无在读班级</h4><p>点击“学员分班”安排课程</p></div>
       <div v-else class="sd-class-grid"><article v-for="(item,index) in classList" :key="item.id || index" class="sd-class-card"><div class="sd-class-title"><h4>{{item.className}}</h4><span class="sd-badge">{{item.consumeType=='2' ? '按金额扣费' : '按课时扣费'}}</span></div><p class="sd-class-subtitle">{{item.courseName}} · {{item.teacherName || '未设置老师'}}</p><div class="sd-class-counts"><div><strong>{{item.inClassStudentCount}}</strong><span>班级学员</span></div><div><strong>{{item.totalRecordCount}}</strong><span>总课次</span></div><div><strong>{{item.approvedRecordCount}}</strong><span>已上课次</span></div></div>
        <div class="sd-class-setting"><span>进班日期</span><b>{{item.joinDate || '—'}}</b><v-btn text small color="#b94852" @click="showUpdateJoinDateCom(item)">修改</v-btn></div>
        <div v-if="item.consumeType=='2'" class="sd-class-setting"><span>学员消课价格</span><b>{{item.classPrice}} 元</b><v-btn text small color="#b94852" @click="showUpdateClassPriceCom(item)">修改</v-btn></div>
        <div v-if="item.isViewTeacherPerformancePrice=='1'" class="sd-class-setting"><span>分成计算价格</span><b>{{item.teacherBonusPrice ? item.teacherBonusPrice+' 元/课时' : '—'}}</b><v-btn text small color="#b94852" @click="showUpdateBonusPriceCom(item)">设置</v-btn></div>
        <div class="sd-class-plans"><span v-for="(plan,idx) in item.classTimePlanList" :key="idx">{{plan.weekName}} {{plan.timeFrom}}–{{plan.timeTo}}</span><span v-if="!item.classTimePlanList || !item.classTimePlanList.length">暂无固定上课时间</span></div>
       </article></div>
      </section></v-tab-item>
      <v-tab-item><section class="sd-schedule"><div class="sd-section-heading"><div><h3>学员课表</h3><p>查询上课安排与核销状态</p></div></div><studentRecordList :studentId="studentId" :classItems="allClassItems" :refreshData="recordListRefreshTime" /></section></v-tab-item>
      <v-tab-item><section class="sd-ledger"><div class="sd-section-heading"><div><h3>学费账户明细</h3><p>查看该学员账户的增加、减少与余额变化</p></div></div>
 <form class="sd-ledger-filters" @submit.prevent="cashQueryClicked"> <v-menu v-model="cashJournal.menu1" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="cashJournal.query.start" label="创建开始日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template><v-date-picker v-model="cashJournal.query.start" @input="cashJournal.menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu><v-menu v-model="cashJournal.menu2" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="cashJournal.query.end" label="创建结束日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template><v-date-picker v-model="cashJournal.query.end" @input="cashJournal.menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu><v-select :items="cashJournal.inOutItems" item-text="text" item-value="id" label="增加 / 减少" dense outlined hide-details v-model="cashJournal.query.inOut" color="#d9363e" /><v-btn depressed color="#d9363e" dark type="submit" :loading="cashJournal.query.loading">查询</v-btn></form>
 <v-data-table :headers="cashJournal.headers" :items="cashJournal.list" :loading="cashJournal.query.loading" class="sd-data-table" :mobile-breakpoint="0"
										disable-pagination hide-default-footer item-key="id" no-data-text="暂无数据" loading-text="正在加载,请稍候......">
										<template v-slot:item.status="{item}">
											<v-chip small :color="cashJournalStatusColor(item.status)">{{ cashJournalStatusName(item.status) }}
											</v-chip>
										</template>
										<template v-slot:item.inOut="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">{{ cashJournalInOutName(item.inOut) }}</span>
											<span v-if="item.inOut=='2'">{{ cashJournalInOutName(item.inOut) }}</span>
										</template>
										<template v-slot:item.amount="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">+{{ item.amount }}</span>
											<span v-if="item.inOut=='2'">-{{ item.amount }}</span>
										</template>

									</v-data-table>
 <div class="sd-pagination"><div><span>共 {{cashJournal.total}} 条</span><v-select :items="[10,20,50,100]" @change="cashJournalSizeChanged" dense disabled hide-details label="每页数量" outlined v-model="cashJournal.query.size" /></div><v-pagination v-if="Math.ceil(cashJournal.total/cashJournal.query.size)>0" :length="Math.ceil(cashJournal.total/cashJournal.query.size)" @input="cashJournalPageChanged" :total-visible="5" v-model="cashJournal.query.page" color="#d9363e" /></div>
 </section></v-tab-item>
      <v-tab-item><section class="sd-ledger"><div class="sd-section-heading"><div><h3>课时账户明细</h3><p>查看该学员账户的增加、减少与余额变化</p></div></div>
 <form class="sd-ledger-filters" @submit.prevent="courseQueryClicked"><v-select :items="courseItems" item-text="courseName" item-value="courseId" label="课程" dense outlined hide-details v-model="courseJournal.query.courseId" color="#d9363e" /> <v-menu v-model="courseJournal.menu1" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="courseJournal.query.start" label="创建开始日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template><v-date-picker v-model="courseJournal.query.start" @input="courseJournal.menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu><v-menu v-model="courseJournal.menu2" :close-on-content-click="false" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="courseJournal.query.end" label="创建结束日期" readonly dense clearable outlined hide-details v-bind="attrs" v-on="on" color="#d9363e" /></template><v-date-picker v-model="courseJournal.query.end" @input="courseJournal.menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu><v-select :items="courseJournal.inOutItems" item-text="text" item-value="id" label="增加 / 减少" dense outlined hide-details v-model="courseJournal.query.inOut" color="#d9363e" /><v-btn depressed color="#d9363e" dark type="submit" :loading="courseJournal.query.loading">查询</v-btn></form>
 <v-data-table :headers="courseJournal.headers" :items="courseJournal.list" :loading="courseJournal.query.loading" class="sd-data-table" :mobile-breakpoint="0"
										disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
										<template v-slot:item.inOut="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">{{ cashJournalInOutName(item.inOut) }}</span>
											<span v-if="item.inOut=='2'">{{ cashJournalInOutName(item.inOut) }}</span>
										</template>

										<template v-slot:item.amount="{item}">
											<span v-if="item.inOut=='1'" style="color: #E65100;">+{{ item.amount }}</span>
											<span v-if="item.inOut=='2'">-{{ item.amount }}</span>
										</template>

									</v-data-table>
 <div class="sd-pagination"><div><span>共 {{courseJournal.total}} 条</span><v-select :items="[10,20,50,100]" @change="courseJournalSizeChanged" dense disabled hide-details label="每页数量" outlined v-model="courseJournal.query.size" /></div><v-pagination v-if="Math.ceil(courseJournal.total/courseJournal.query.size)>0" :length="Math.ceil(courseJournal.total/courseJournal.query.size)" @input="courseJournalPageChanged" :total-visible="5" v-model="courseJournal.query.page" color="#d9363e" /></div>
 </section></v-tab-item>
     </v-tabs-items>
    </v-card-text>
   </v-card>
  </v-dialog>
  <!-- 学员缴费组件 -->
		<studentRecharge :show="rechargeShow" :student="student" @cancel="rechargeShow=false" @success="rechareSuccess"></studentRecharge>
		<!-- 修改班级价格组件 -->
		<updateStudentPrice :show="updatePriceShow" :classStudent="classStudent" @cancel="updatePriceShow=false" @success="updatePriceSuccess"></updateStudentPrice>
		<!-- 学员加入班级 -->
		<studentJoinClass :show="joinClassShow" :student="student" @cancel="joinClassShow=false" @success="joinClassSuccess"></studentJoinClass>
		<!-- 修改学员资料 -->
		<updateStudent :show="updateStudentShow"  :student="student" @cancel="updateStudentShow=false" @success="updateStudentSuccess"></updateStudent>
		<!-- 绑定家长手机号组件 -->
		<bindParentMobile :show="bindParent.show" :studentId="bindParent.studentId" :studentName="bindParent.studentName"
			@cancel="bindParent.show=false" @success="bindParentSuccess"></bindParentMobile>
		<!-- 修改进班日期组件 -->
		<updateStudentJoinDate :show="updateJoinDate.show" :classStudent="updateJoinDate.classStudent" @cancel="updateJoinDate.show=false"
			@success="updateJoinDateSuccess"></updateStudentJoinDate>

		<!-- 修改提成计算价格组件 -->
		<updateStudentTeacherBonusPrice :show="updateBonusPriceShow" :classStudent="classStudent" @cancel="updateBonusPriceShow=false" @success="updateBonusPriceSuccess"></updateStudentTeacherBonusPrice>
		<!-- 图片预览 -->
		<imageViewer :show="imageViewerDialog.show" :imgSrc="imageViewerDialog.imgSrc" imgWidth="400" imgHeight="400" @cancel="imageViewerDialog.show=false"></imageViewer>
		<!-- 学员状况列表 -->
		<studentSituationList :show="situationListDialog.show" :studentId="situationListDialog.studentId" @cancel="situationListDialog.show=false"></studentSituationList>

 </div>
</template>

<script>
	import studentRecharge from "./student_recharge.vue"
	import updateStudentPrice from "./update_student_price.vue"
	import studentJoinClass from "./student_join_class.vue"
	import updateStudent from "./update_student.vue"
	import bindParentMobile from "./bind_parent_mobile.vue"
	import studentRecordList from "./student_record_list.vue"
	import updateStudentJoinDate from "./update_student_join_date.vue"
	import updateStudentTeacherBonusPrice from "./update_student_teacher_bonus_price.vue"
	import imageViewer from "./image_viewer.vue"
	import studentSituationList from "./student_situation_list.vue"
	export default {
		name: "student-detail",
		components:{
			studentRecharge,
			updateStudentPrice,
			studentJoinClass,
			updateStudent,
			bindParentMobile,
			studentRecordList,
			updateStudentJoinDate,
			updateStudentTeacherBonusPrice,
			imageViewer,
			studentSituationList
		},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			
			studentId:{
				type:String,
				default:""
			}

		},
		watch: {
			show(newVal, oldVal) {
				console.log("newVal", newVal);
				this.hideShow = newVal;
                Object.keys(this.loadRequestIds).forEach(key => { this.loadRequestIds[key]++; });
				if(newVal){
					this.tab = 0;
					this.student = null;
                    this.accountList = []; this.classList = []; this.courseItems = []; this.allClassItems = [];
                    this.detailError = ''; this.accountError = ''; this.classError = '';
					// 清空cashjournal的数据
					this.cashJournal.query.page= 1;
					this.cashJournal.query.size = 10;
					this.cashJournal.total = 0;
					this.cashJournal.list = [];
					
					// 清空coursejournal的数据
					this.courseJournal.query.courseId = "";
					this.courseJournal.query.page= 1;
					this.courseJournal.query.size = 10;
					this.courseJournal.total = 0;
					this.courseJournal.list = [];
					this.courseJournal.myCourseItems = [];
					
				
					this.getStudentDetail();
					this.getAccountList();
					this.getClassList();
					
				
				}
			},

		},
		data() {
			return {
				imgPrev:"https://photo.youkeya.cn/",
				tab:null,
				hideShow: this.show,
				student:null,
                detailLoading:false, accountLoading:false, classLoading:false,
                detailError:'', accountError:'', classError:'',
                loadRequestIds:{detail:0,account:0,class:0},
				rechargeShow:false, // 控制学员缴费组件的显示
				updatePriceShow:false, // 控制修改学员扣费价格的组件显示
				joinClassShow:false, //控制加入班级组件的显示
				updateStudentShow:false,//控制修改班级组件的显示
				updateBonusPriceShow:false, //控制修改教师提成价格的显示
				parentMobile:"", //家长账号
				accountList:[],// 账户信息
				classList:[],// 班级列表
				allClassItems:[], // 学员的所有就读班级
				courseItems:[], // 课时账户的课程列表
				recordListRefreshTime:"", // 学员课表刷新标记 点击tab就刷新
				bindParent:{
					show:false,
					studentId:"",
					studentName:""
				},
				updateJoinDate:{
					show:false,
					classStudent:null
				},
				imageViewerDialog:{
					show:false,
					imgSrc:"",
				},
				situationListDialog:{
					show:false,
					studentId:"",
				},
				cashJournal:{
					// 学费明细
					total:0,
					menu1:false,
					menu2:false,
					query:{
						loading: false,
						page: 1,
						size: 10,
						start: "",
						end: "",
						inOut:""
					},
					inOutItems:[{id:"",text:"全部"},{id:"1",text:"增加"},{id:"2",text:"减少"}],
					headers:[
						{
							text: '业务时间',
							value: 'createAt',
							sortable: false,
							width:"170"
						},
						{
							text: '增/减',
							value: 'inOut',
							sortable: false,
							width:"70"
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false,
							width:"130"
						},
						{
							text: '业务前',
							value: 'lastAmount',
							sortable: false
						},
						{
							text: '本次学费',
							value: 'amount',
							sortable: false
						},
						{
							text: '业务后',
							value: 'balanceAmount',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list:[]
				},
				courseJournal:{
					// 课时明细
					total:0,
					menu1:false,
					menu2:false,
					query:{
						loading: false,
						page: 1,
						size: 10,
						courseId:"",
						start: "",
						end: "",
						inOut:""
					},
					inOutItems:[{id:"",text:"全部"},{id:"1",text:"增加"},{id:"2",text:"减少"}],
					headers:[
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false,
							width:"150"
						},
						{
							text: '业务时间',
							value: 'createAt',
							sortable: false,
							width:"180"
						},
						{
							text: '增/减',
							value: 'inOut',
							sortable: false,
							width:"70"
						},
						{
							text: '业务类型',
							value: 'bizType',
							sortable: false,
							width:"120"
						},
						{
							text: '业务前',
							value: 'lastAmount',
							sortable: false,
							width:"70"
						},
						{
							text: '本次课时',
							value: 'amount',
							sortable: false,
							width:"90"
						},
						{
							text: '业务后',
							value: 'balanceAmount',
							sortable: false,
							width:"80"
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
					],
					list:[]
				},
				classStudent:{},
			}
		},
		mounted() {
			//this.getShopListForSelect();
			console.log("student detail mounted");
		},
        beforeDestroy() { Object.keys(this.loadRequestIds).forEach(key => { this.loadRequestIds[key]++; }); },
		computed: {
			accountGroups() {
				const otherAccounts = [];
				const zeroHourAccounts = [];
				this.accountList.forEach(item => {
					const balance = item.balanceAmount;
					const isZeroHourAccount = item.accountType === 'TIMES' && balance != null && String(balance).trim() !== '' && Number(balance) === 0;
					(isZeroHourAccount ? zeroHourAccounts : otherAccounts).push(item);
				});
				return [
					{ key: 'other', items: otherAccounts },
					{ key: 'zero', items: zeroHourAccounts },
				].filter(group => group.items.length > 0);
			},
		},
		methods: {
			genderName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "男生";
				} else if (state === "0") {
					stName = "女生";
				}
				return stName;
			},
			genderColor(state) {
				let color = "";
				if (state === "1") {
					color = "blue lighten-4";
				} else if (state === "0") {
					color = "pink lighten-4";
				}
			
				return color;
			},
			studentStatusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "在读";
				} else if (state === "0") {
					stName = "冻结";
				} else if (state === "2") {
					stName = "结业";
				} else if (state === "3") {
					stName = "意向";
				} else if (state === "4") {
					stName = "无意向";
				}
				return stName;
			},
			studentStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				} else if (state === "2") {
					color = "primary";
				} else if (state === "3") {
					color = "warning";
				} else if (state === "4") {
					color = "error";
				}
			
				return color;
			},
			tabChanged(e){
                this.$nextTick(() => { if (this.$refs.detailScroll) this.$refs.detailScroll.scrollTop = 0; });
                if (!this.student) return;
				if(e == 2){
					// 学员课表
					// 设置刷新
					let randNum = Math.random();
					this.recordListRefreshTime =  randNum.toString();
					
				}else if(e ==3 ) {
					// 现金账户明细
					this.cashJournal.query.page = 1;
					this.getCashJournalList();
				}else if(e==4){
					// 课程账户明细
					this.courseJournal.query.page = 1;
					this.getCourseJournalList();
				}
			},
			cancel() {
				this.$emit("cancel", "");
			},
			showImageViewer(imgSrc){
				this.imageViewerDialog.imgSrc = imgSrc;
				console.log(imgSrc);
				this.imageViewerDialog.show=true;
			},
			showSituationList(){
				// 显示全部状况
				this.situationListDialog.studentId = this.studentId;
				this.situationListDialog.show =true;
				
			},
            async loadDetailSection(section, url, apply) {
                const requestId = ++this.loadRequestIds[section];
                const studentId = this.studentId;
                this[section+'Loading'] = true;
                this[section+'Error'] = '';
                try {
                    const response = await this.axios.get(url);
                    if (requestId !== this.loadRequestIds[section] || studentId !== this.studentId) return;
                    if (response.data.code !== 200) throw new Error(response.data.message || '加载失败，请重试');
                    apply(response.data.data);
                } catch (error) {
                    if (requestId === this.loadRequestIds[section] && studentId === this.studentId) {
                        this[section+'Error'] = error.response ? '加载失败，请稍后重试' : (error.message || '加载失败，请稍后重试');
                    }
                } finally {
                    if (requestId === this.loadRequestIds[section] && studentId === this.studentId) this[section+'Loading'] = false;
                }
            },
            getStudentDetail() {
                return this.loadDetailSection('detail', `/edu/student/detail/${this.studentId}`, data => {
                    if (!data || Array.isArray(data) || !data.id) throw new Error('未获取到学员信息，请重试');
                    this.student = data;
                });
            },
            getAccountList() {
                return this.loadDetailSection('account', `/financial/student/all/account/list/${this.studentId}`, data => {
                    this.accountList = Array.isArray(data) ? data : [];
                    this.courseItems = this.accountList.filter(item => item.accountType === 'TIMES').map(item => ({courseId:item.courseId,courseName:item.courseName}));
                });
            },
            getClassList() {
                return this.loadDetailSection('class', `/edu/student/all/class/list/${this.studentId}`, data => {
                    this.classList = Array.isArray(data) ? data : [];
                    this.allClassItems = this.classList.map(item => ({id:item.classId,className:item.className}));
                });
            },
			cashQueryClicked(){
				this.cashJournal.query.page = 1;
				this.getCashJournalList();
			},
			cashJournalSizeChanged(size) {
				this.cashJournal.query.size = size;
				this.cashJournal.query.page = 1;
				this.getCashJournalList();
			},
			cashJournalPageChanged(page) {
				this.cashJournal.query.page = page;
				this.getCashJournalList();
			},
			getCashJournalList(){
				const that = this;
				this.cashJournal.query.loading = true;
				
				
				let url = `/financial/student/cash/journal/list/page/${that.cashJournal.query.page - 1}/size/${that.cashJournal.query.size}?v=1`;
				url += "&studentNo=" + this.student.studentNo;
				
				if (this.cashJournal.query.start) {
					url += "&start=" + this.cashJournal.query.start;
				}
				if (this.cashJournal.query.end) {
					url += "&end=" + this.cashJournal.query.end;
				}
				if (this.cashJournal.query.inOut) {
					url += "&inOut=" + this.cashJournal.query.inOut;
				}

				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						
						that.cashJournal.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.cashJournal.total = response.data["data"]["count"];
				
						that.cashJournal.query.loading = false;
						return
					}
					that.cashJournal.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			cashJournalInOutName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "增加";
				} else if (state === "2") {
					stName = "减少";
				}
				return stName;
			},
			cashJournalInOutColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "error";
				}
				return color;
			},
			cashJournalStatusName(state) {
			
				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "冻结";
				}
				return stName;
			},
			cashJournalStatusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}
			
				return color;
			},
			courseQueryClicked(){
				this.courseJournal.query.page = 1;
				this.getCourseJournalList();
			},
			courseJournalSizeChanged(size) {
				this.courseJournal.query.size = size;
				this.courseJournal.query.page = 1;
				this.getCourseJournalList();
			},
			courseJournalPageChanged(page) {
				this.courseJournal.query.page = page;
				this.getCourseJournalList();
			},
			getCourseJournalList(){
				
				const that = this;
				this.courseJournal.query.loading = true;
				
				
				let url = `/financial/student/account/journal/list/page/${that.courseJournal.query.page - 1}/size/${that.courseJournal.query.size}?v=1`;
				url += "&studentNo=" + this.student.studentNo;
				if (this.courseJournal.query.courseId) {
					url += "&courseId=" + this.courseJournal.query.courseId;
				}
				
				if (this.courseJournal.query.start) {
					url += "&start=" + this.courseJournal.query.start;
				}
				if (this.courseJournal.query.end) {
					url += "&end=" + this.courseJournal.query.end;
				}
				if (this.courseJournal.query.inOut) {
					url += "&inOut=" + this.courseJournal.query.inOut;
				}
			
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						
						that.courseJournal.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.courseJournal.total = response.data["data"]["count"];
				
						that.courseJournal.query.loading = false;
						return
					}
					that.courseJournal.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			rechareSuccess(){
				// 学员缴费成功
				this.rechargeShow = false;
				this.getAccountList();
			},
			showUpdateClassPriceCom(item){
				this.updatePriceShow = true;
				this.classStudent = item;
			},
			showUpdateBonusPriceCom(item){
				this.updateBonusPriceShow = true;
				this.classStudent = item;
			},
			updatePriceSuccess(){
				//修改价格成功
				this.updatePriceShow = false;
				this.getClassList();
			},
			updateBonusPriceSuccess(){
				this.updateBonusPriceShow = false;
				this.getClassList();
			},
			showUpdateJoinDateCom(item){
				// 显示修改入班日期
				this.updateJoinDate.show = true;
				this.updateJoinDate.classStudent = item;
			},
			updateJoinDateSuccess(){
				//修改日期成功
				this.updateJoinDate.show = false;
				this.getClassList();
			},
			joinClassSuccess(){
				//加入班级成功
				this.joinClassShow = false;
				this.getClassList();
			},
			updateStudentSuccess(){
				this.updateStudentShow = false;
				this.getStudentDetail();
			},
			showBindParentMobile(){
				this.bindParent.studentId = this.student.id;
				this.bindParent.studentName = this.student.studentName;
				this.bindParent.show = true;
			},
			bindParentSuccess(){
				this.bindParent.show=false;
				this.getStudentDetail();
			},
			unbindParentMobile(){
				// 解绑家长手机号
				// api
				const that = this;
				let url = `/edu/student/app/user/mobile/unbind/${this.studentId}`;
				
				
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("解绑成功");
							this.getStudentDetail();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
			closeStudent() {
				// 设置学员为毕业
				const studentId = this.studentId;
				// api
				const that = this;
				let url = `/edu/student/close/${studentId}`;
			
				this.axios.post(url, {}).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getStudentDetail();
			
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
			
				});
			
			},
			openStudent(){
				// 结业学员复学
				const studentId = this.studentId;
				// api
				const that = this;
				let url = `/edu/student/open/${studentId}`;
				
				this.axios.post(url, {}).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getStudentDetail();
				
							return;
						} else {
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.$noty.error('网络请求失败');
					}
				
				});
			},
		}
	}
</script>

<style scoped lang="scss" src="../assets/styles/student-detail.scss"></style>
